module.exports = __webpack_public_path__ + "static/media/top-contacts-zero-state.97589940.svg";